/**
 * @chineseName 上传
 * @subDescription m-ui组件 上传
 */
import Upload from './Upload';
import Dragger from './Dragger';
Upload.Dragger = Dragger;
export default Upload;